import AnimationComponent from '../../../Component/Animation';
import Element from '../../../Prototype/UI/Element';
import { tVector4 } from '../../../Utility/ArrayHelper';
import PIXIRenderer from '../../../System/Render/PIXIRenderer';
import { Point } from 'pixi.js';
import {
    StartAnimationClip,
    GetAnimationClip,
} from '../../../System/Animation/AnimationHelper';
import { AnimationClipEvent } from '../../../System/Animation/AnimationClip';

export default class HarvestCrop extends Element {
    public delay: number = 0;

    public create(params: {
        [key: string]: any;
        cropPosition: Point;
        delay?: number;
    }): void {
        this.delay = params.delay || 0;
        const worldPosition: Point = params.cropPosition.clone();
        const screenPos: PIXI.Point = PIXIRenderer.mapViewport.toScreen(
            worldPosition
        );
        const offsets: tVector4 = [
            -screenPos.x,
            -screenPos.y,
            -screenPos.x,
            -screenPos.y,
        ];
        super.create({
            name: params.name,
            layout: {
                offsets: offsets,
                scale: [0, 0],
            },
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: params.texture,
                    },
                },
            ],
            ...params,
        });
        this.addComponent(AnimationComponent);
    }

    public play(destination: Point): void {
        StartAnimationClip(
            GetAnimationClip('RewardPopIn', this, { delay: this.delay }).on(
                AnimationClipEvent.COMPLETE,
                clip => {
                    StartAnimationClip(
                        GetAnimationClip(
                            'CropRewardTranslate',
                            clip.gameObject,
                            {
                                destination: destination,
                                duration: 2000,
                            }
                        ).on(AnimationClipEvent.COMPLETE, () => this.destroy())
                    );
                }
            )
        );
    }
}
